import { ref } from 'vue'

import type { RoomId } from '@/types'

import type { LastRoom } from './useLastRoom.types'
import storage from './useLastRoom.storage'

const active = ref(true)
const lastRoom = ref<LastRoom | null>(storage.get())

function setLastRoom(id: RoomId, name: string) {
  const data = { id, name }
  lastRoom.value = data
  storage.set(data)
}

function discard() {
  active.value = false
}

export default function useLastRoom() {
  return {
    active,
    lastRoom,
    setLastRoom,
    discard,
  }
}
